import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {FireService} from './fire.service';

export interface NotificationSnapshot {
  count: number;
  anyUnread: boolean;
  chatId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private notificationSubject = new BehaviorSubject<NotificationSnapshot>({count: 0, anyUnread: false, chatId: undefined});
  //notifications$ = this.notificationSubject.asObservable();
  private sub?: Subscription;
  private lastReadDate?: Date;

  constructor(private fire: FireService) {}

  observeNotifications(chatId: number): Observable<NotificationSnapshot> {
    const chatIdChanged = this.notificationSubject.getValue().chatId !== chatId;
    if (!this.sub || chatIdChanged) {
      this.sub?.unsubscribe();
      this.initService(chatId);
    }
    return this.notificationSubject.asObservable();
  }

  private initService(chatId: number) {
    const storedDate = localStorage.getItem("lastReadDate");
    this.lastReadDate = storedDate ? new Date(storedDate) : undefined;

    const dateBack = new Date();
    dateBack.setHours(dateBack.getHours() - 6);
    this.sub = this.fire.observeEventsWindow(chatId, dateBack).subscribe(events => {
      console.log("Events", events);
      // receipt = !e.content && e.type==='generic
      // voucher = e.vouchers != null
      // order = e.content_json != null
      const orderEvents = events.filter(e => e.content_json != null || (!e.content && e.type==='generic') || e.vouchers != null);

      const anyUnread = this.lastReadDate ?
        orderEvents.some(e => e.date?.toDate()! > this.lastReadDate!) :
        true;

      this.notificationSubject.next({count: orderEvents.length, anyUnread, chatId});
    });
  }

  markRead() {
    this.lastReadDate = new Date();
    //Save to local storage
    localStorage.setItem("lastReadDate", this.lastReadDate.toISOString());
    const snapshot = this.notificationSubject.getValue();
    this.notificationSubject.next({count: snapshot.count, anyUnread: false, chatId: snapshot.chatId});
  }

}
